import { Tooltip } from "@chakra-ui/react";
import { BiBlock } from "react-icons/all";

import { Icon } from "components/Icon";
import { IconButton, IconButtonProps } from "components/IconButton";

interface IProps extends Omit<IconButtonProps, "aria-label"> {
  appointmentId: string;
}

const CancelAppointmentButton = ({ appointmentId, ...props }: IProps) => {
  const cancelMessage = "Anulowanie wizyty";

  return (
    <Tooltip label={cancelMessage} aria-label={cancelMessage}>
      <IconButton
        id={`cancel-appointment-${appointmentId}-icon-btn`}
        background="transparent"
        icon={<Icon w={5} h={5} color="black.900" icon={BiBlock} />}
        aria-label={cancelMessage}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        {...props}
      />
    </Tooltip>
  );
};

export { CancelAppointmentButton };
